import ContentWrapper from "@/components/Core/ContentWrapper";
import SectionTitle from "@/components/Shared/SectionTitle";
import mq from "@/utils/mq";
import { ThemeOption } from "@/utils/ThemeProvider";
import styled from "styled-components";
import { css } from "styled-components";

const SectionContent = styled.div<{ $noPaddingTop?: boolean; $noBottomPadding?: boolean }>`
  padding-top: 6rem;
  padding-bottom: 6rem;
  ${(props) =>
    props.$noPaddingTop &&
    css`
      padding-top: 0;
    `}
  ${(props) =>
    props.$noBottomPadding &&
    css`
      padding-bottom: 0;
    `}
  ${mq.mobile(css<{ $noPaddingTop?: boolean; $noBottomPadding?: boolean }>`
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
    ${(props) =>
      props.$noPaddingTop &&
      css`
        padding-top: 0;
      `}
    ${(props) =>
      props.$noBottomPadding &&
      css`
        padding-bottom: 0;
      `}
  `)};
`;

const SectionTitleWrapper = styled.div<{ $mobilePaddingTitle?: boolean }>`
  width: 100%;
  ${({ $mobilePaddingTitle }) =>
    $mobilePaddingTitle &&
    css`
      ${mq.mobile(css`
        padding: 0 22px;
      `)};
    `}
`;

const Content = styled.div``;

export default function SectionContentWrapper({
  sectionTitle,
  backgroundColor,
  children,
  theme,
  noMobilePadding,
  tabTitleMode,
  mobilePaddingTitle,
  darkMode = false,
  noPaddingTop = false,
  noBottomPadding = false,
}: {
  sectionTitle: any;
  backgroundColor?: string;
  children?: React.ReactNode;
  theme?: ThemeOption;
  noMobilePadding?: boolean;
  tabTitleMode?: boolean;
  mobilePaddingTitle?: boolean;
  darkMode?: boolean;
  noPaddingTop?: boolean;
  noBottomPadding?: boolean;
}) {
  return (
    <ContentWrapper
      backgroundColor={backgroundColor}
      theme={theme}
      noMobilePadding={noMobilePadding}
      darkMode={darkMode}>
      <SectionContent $noPaddingTop={noPaddingTop} $noBottomPadding={noBottomPadding}>
        <SectionTitleWrapper $mobilePaddingTitle={mobilePaddingTitle}>
          <SectionTitle
            sectionTitle={sectionTitle}
            tabTitleMode={tabTitleMode}
            parentTheme={theme}
            darkMode={theme === "dark" ? true : darkMode}
          />
        </SectionTitleWrapper>
        <Content>{children}</Content>
      </SectionContent>
    </ContentWrapper>
  );
}
